<template>
  <div class="login-container">
    <img class="logo" :src="huizhaowangLogo" />

    <div class="tab-container login-tab-container">
      <van-tabs v-model="activeName" color="#3D8FFD" swipeable:true>
        <van-tab title="微信登录" name="wxLogin">
          <div class="line-height"></div>
          <span class="wechat-login" @click="weixinAuth()">
            <img :src="arrow" />
            <span>微信快捷登录</span>
          </span>

          <div class="line-icon">
            <div class="line"></div>
            <img :src="wxIcon1" />
            <div class="line1"></div>
          </div>
        </van-tab>

        <van-tab title="账号密码登录" name="accountLogin">
          <div class="input-container">
            <span class="input-title">手机号</span>
            <div class="input-field-container">
              <van-field class="input-field" type="number" v-model="login_mobile" placeholder="请输入手机号" maxlength="11" />
            </div>
          </div>
          <div class="input-container">
            <span class="input-title">密码</span>
            <div class="input-field-container">
              <template v-if="!showLoginPassword">
                <van-field class="input-field" v-model="login_password" type="password" placeholder="请输入密码" />
                <img class="hide-icon" @click="showLoginPassword = true" :src="hideIcon" />
              </template>
              <template v-else>
                <van-field class="input-field" v-model="login_password" placeholder="请输入密码" />
                <img class="hide-icon" @click="showLoginPassword = false" :src="showIcon" />
              </template>
            </div>
          </div>
          <a class="btn" @click="loginConfirm">登录</a>
        </van-tab>
      </van-tabs>

      <p class="tip">
        还没有慧招网账号？
        <router-link to="/register">立即注册</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Field, Checkbox, Toast, Divider } from 'vant';

export default {
  data() {
    return {
      hideIcon: require('@/assets/image/hide-icon.png'),
      showIcon: require('@/assets/image/show-icon.png'),
      huizhaowangLogo: require('@/assets/image/huizhaowang-logo.png'),
      wxIcon: require('@/assets/image/wx-btn.png'),
      arrow: require('@/assets/image/arrow.png'),
      wxIcon1: require('@/assets/image/wx-icon.png'),
      list: [{}],
      active: '',
      login_mobile: '',
      login_password: '',
      register_password: '',
      register_password_confirm: '',
      checked: 'true',
      showLoginPassword: false,
      showRegisterPassword: false,
      showRegisterPasswordConfirm: false,
      redirectUrl: '',
      openid: '',
      screenHeight: 0,
      screenHeightTemp: 0,
      activeName: '',
    };
  },
  created() {
    let codeid = 'M-Login-Page';
    let url = this.$route.path;
    this.TRACKER.tracking(codeid, url);
    localStorage.setItem('memberid', '');
    localStorage.setItem('token', '');
  },
  mounted() {
    let that = this;
    that.screenHeight = document.documentElement.clientHeight;
    window.onresize = () => {
      that.screenHeightTemp = document.documentElement.clientHeight;
    };
  },
  watch: {
    screenHeightTemp(newVal, oldVal) {
      if (newVal < this.screenHeight) {
        document.getElementById('vanTabbar').style.display = 'none';
      } else {
        document.getElementById('vanTabbar').style.display = 'flex';
      }
    },
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
  },
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' });
        return;
      } else {
        this.$router.go(-1);
      }
    },
    onClickTab(data) {},
    retrievePasswordTracking() {
      let codeid = 'M-Retrieve-Password';
      let url = this.$route.path;
      this.TRACKER.tracking(codeid, url);
    },
    registerPageTracking() {
      let codeid = 'M-Register-Page';
      let url = this.$route.path;
      this.TRACKER.tracking(codeid, url);
    },
    readServiceAgreementTracking() {
      let codeid = 'M-Read-Service-Agreement';
      let url = this.$route.path;
      this.TRACKER.tracking(codeid, url);
    },
    onLogin() {
      this.$router.push({
        path: '/login',
      });
    },

    //登录
    loginConfirm() {
      let loginPassword = this.login_password;
      let mobilephone = this.login_mobile;
      var phoneRegExp = /^1[34578]\d{9}$/;
      if (mobilephone == null || mobilephone == '') {
        Toast('手机号不能为空');
        return;
      } else if (!phoneRegExp.test(mobilephone)) {
        Toast('手机号码不正确');
        return;
      }
      if (loginPassword == null || loginPassword == '') {
        Toast('登录密码不能为空');
        return;
      }

      const that = this;
      let params = { username: mobilephone, password: loginPassword };
      this.$axios.defaults.headers = {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      };
      var querystring = require('querystring');
      params = querystring.stringify(params);
      this.$axios.post(this.COMMON.baseURL + '/member/login/main', params).then(
        function(res) {
          let result = res.data;
          if (result.status == 'SUCCESS') {
            //设置token到local
            localStorage.setItem('token', result.message);
            //设置memberid到local
            localStorage.setItem('memberid', result.data);
            Toast('登录成功');

            that.goBack();
          } else {
            if (result.errorcode == 'account_not_exist' || result.errorcode == 'password_error') {
              Toast('用户名或者密码不正确');
            } else {
              Toast('登录失败');
            }
          }
        },
        function(res) {
          console.log('请求失败处理!');
        }
      );
    },
    //微信登录
    weixinAuth() {
      let redirectUrl = this.COMMON.wxRedirectUrl + 'fakeLogin';
      let authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize';
      let authParams = '?appid=' + this.COMMON.appid + '&redirect_uri=' + redirectUrl + '&response_type=code&scope=snsapi_userinfo&connect_redirect=1#wechat_redirect';
      window.location.href = authPageBaseUri + authParams;
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  background: #fff;
  text-align: center;
  min-height: 100vh;

  /deep/.van-tab--active {
    font-weight: 600;
  }

  /deep/.van-tab {
    color: black;
    font-size: 16px;
    line-height: 50px;
    padding-top: 12px;
  }

  .logo {
    margin-top: 20px;
    width: 159px;
    height: 50px;
  }
  .tab-container {
    .line-height {
      height: 50px;
    }
    .wechat-login {
      display: inline-block;
      background-color: #02bd6e;
      color: white;
      font-size: 16px;
      padding: 15px 0px 0px 20px;
      font-weight: normal;
      border-radius: 6px;
      width: 280px;
      height: 35px;
      position: relative;
      img {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 11px;
        left: 26%;
      }
    }
    .line-icon {
      height: 50px;
      position: relative;
      margin-top: 30px;
      .line {
        background-color: #02bd6e;
        height: 2px;
        width: 65px;
        position: absolute;
        top: 50%;
        left: 80px;
      }
      .line1 {
        background-color: #02bd6e;
        height: 2px;
        width: 65px;
        position: absolute;
        top: 50%;
        right: 80px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }

    .input-container {
      width: 311px;
      margin: 0 auto;
      text-align: left;

      &:first-child {
        margin-top: 15px;
      }

      &:nth-child(2) {
        margin-top: 3px;
      }

      &:nth-child(3) {
        margin-top: 20px;
      }

      .input-title {
        height: 20px;
        font-size: 13px;
        font-family: HelveticaNeue;
        color: rgba(155, 158, 169, 1);
        line-height: 20px;
      }

      .input-field-container {
        position: relative;

        .input-field {
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 8px 16px 2px rgba(119, 154, 241, 0.2);
          border-radius: 4px;
          color: #000;
          font-size: 14px;
          font-weight: 500;
          font-family: HelveticaNeue-Medium, HelveticaNeue;
          padding: 8px 8px;

          /deep/ .van-field__control {
            height: 36px;
          }
        }

        .hide-icon {
          position: absolute;
          right: 16px;
          top: 16px;
        }
      }
    }

    .btn {
      display: inline-block;
      margin-top: 30px;
      // width: 311px;
      // height: 48px;
      width: 300px;
      height: 41px;
      background: linear-gradient(360deg, rgba(49, 130, 254, 1) 0%, rgba(82, 164, 249, 1) 100%);
      border-radius: 4px;
      font-size: 18px;
      font-family: HelveticaNeue-Medium, HelveticaNeue;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      // line-height: 48px
      line-height: 42px;
      position: relative;
      top: 11px;
    }

    .btn-wx {
      display: inline-block;
      margin-top: 30px;
      // width: 311px;
      // height: 48px;
      width: 300px;
      height: 40px;
      background: linear-gradient(360deg, rgba(0, 194, 151, 1) 0%, rgb(57, 212, 179) 100%);
      border-radius: 4px;
      font-size: 18px;
      font-family: HelveticaNeue-Medium, HelveticaNeue;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      // line-height: 48px
      line-height: 42px;
      position: initial;
      right: 38px;
      top: 342px;
      margin-bottom: 80px;
    }

    .horizontal-line {
      margin: 30px auto 0;
      width: 311px;
      //background:#e5e5e5;
      background: url(../../assets/image/line.png) no-repeat left 50%;
      text-align: center;
      span {
        color: #aaaaaa;
        font-size: 15px;
        background-color: #ffffff;
        width: 141px;
        display: block;
        margin-left: 85px;
      }
    }
    .tips-text {
      font-size: 15px;
      color: #aaaaaa;
      background-color: #ffffff;
      line-height: 40px;
    }
    .wx-icon {
      width: auto;
      height: 80%;
      position: relative;
      left: -16px;
      bottom: -6px;
    }
    .wx-btn-text {
      position: relative;
      top: -4px;
      left: -10px;
    }
  }

  .login-tab-container {
    .forgot-password-btn {
      display: block;
      margin-top: 40px;
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(76, 105, 255, 1);
      line-height: 18px;
    }
  }

  .register-container {
    .agree-checkbox {
      width: 172px;
      margin: 40px auto 0;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      color: #666666 !important;

      span {
        color: #4c69ff;
      }
    }

    .btn {
      margin-top: 28px;
    }
  }
  .tip {
    font-size: 14px;
    text-align: right;
    padding: 10px 40px;
    color: #999;
    a {
      color: rgba(49, 130, 254, 1);
    }
  }
}

/deep/ .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
</style>
